import React from 'react';
import { CardSubtitle, CardTitle } from '@bexs/dollar/components/Card';
import Column from '@bexs/dollar/components/GridColumn';

const Title: React.FC = () => (
  <Column>
    <CardTitle>Upload new file</CardTitle>
    <CardSubtitle>
      Enter the date the report was generated and upload your CSV file.
    </CardSubtitle>
  </Column>
);

export default Title;
